define('gigaset_recurring/classes/checkout/progressbar',[
	"jquery",
	"lodash",
	"cartware/jquery/bem",
	"lucid"
], function(
	$,
	_,
	BEM,
	lucidJS
) {
	function Step(tmpl, number, label) {
		lucidJS.EventEmitter.call(this);
		this.number = number;
		this.label = label;
		this.domNode = $(tmpl(this));

		this.domNode.on("click", _.bind(function() {
			this.emit("click");
		}, this));
	}

	Step.prototype = _.create(new lucidJS.EventEmitter, {
		number:		null,
		label:		null,
		domNode:	null,

		setComplete: function(flag) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this.domNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("complete");
		},

		setActive: function(flag) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this.domNode[flag ? "bemAddModifier" : "bemRemoveModifier"]("current");
		}
	});

	function ProgressBar (block) {
		this.block = BEM.block(block);
		this.list = this.block.getElements("list");
		this.stepTmpl = _.template(this.block.getElements("progress-bar-step").html());
		this.steps = [];
	}

	ProgressBar.prototype = {
		block:		null,
		list:		null,
		stepTmpl:	null,
		steps:		null,

		addStep: function(label) {
			var step = new Step(this.stepTmpl, this.steps.length + 1, label);
			step.domNode.bemAddModifier('last');

			_.forEach(this.steps, function(step) { step.domNode.bemRemoveModifier('last'); });
			_.forEach(this.steps, function(step) { step.domNode.bemRemoveModifier('first'); });

			this.steps.push(step);
			this.list.append(step.domNode);

			_.first(this.steps).domNode.bemAddModifier('first');

			return step;
		}
	}

	return ProgressBar;
});
